export default __webpack_public_path__ + "static/media/04_photo.3e8ba768.jpg";